import { FeatureFlagsInstance } from '@/services/service';
import axios from 'axios';

export type FeatureFlagRecord = {
  pk: string;
  sk: string;
  value: unknown;
  created_at: string;
  created_by: string;
  updated_at: string;
  updated_by: string;
};

const BASE_PATH = '/feature-flags';

const encodePathSegment = (value: string) => encodeURIComponent(value);
const isMissingFeatureFlagError = (error: unknown) =>
  axios.isAxiosError(error) && error.response?.status === 404;

const getByPath = async <T>(path: string): Promise<T> =>
  (await FeatureFlagsInstance.get<T>(path)) as T;

const getFeatureFlag = async (url: string): Promise<FeatureFlagRecord | null> => {
  try {
    return await getByPath<FeatureFlagRecord>(url);
  } catch (error) {
    if (isMissingFeatureFlagError(error)) return null;
    throw error;
  }
};

export const listGlobalFlags = () => getByPath<FeatureFlagRecord[]>(`${BASE_PATH}/all/`);

export const listTenantFlags = (tenantId: string) =>
  getByPath<FeatureFlagRecord[]>(`${BASE_PATH}/all/${encodePathSegment(tenantId)}`);

export const listUserFlags = (tenantId: string, userId: string) =>
  getByPath<FeatureFlagRecord[]>(
    `${BASE_PATH}/all/${encodePathSegment(tenantId)}/${encodePathSegment(userId)}`,
  );

export const getGlobalFlag = (slug: string) =>
  getFeatureFlag(`${BASE_PATH}/${encodePathSegment(slug)}`);

export const getTenantFlag = (slug: string, tenantId: string) =>
  getFeatureFlag(`${BASE_PATH}/${encodePathSegment(slug)}/${encodePathSegment(tenantId)}`);

export const getUserFlag = (slug: string, tenantId: string, userId: string) =>
  getFeatureFlag(
    `${BASE_PATH}/${encodePathSegment(slug)}/${encodePathSegment(tenantId)}/${encodePathSegment(userId)}`,
  );
